import React, { useState, useEffect } from "react";
import { aboutChapterApi, getImageUrl } from "../api";
import ImageLoader from "./common/ImageLoader";
import "./AdminAboutChapter.css";

const AdminAboutChapter = () => {
  const [about, setAbout] = useState(null);
  const [description, setDescription] = useState("");
  const [activeMembers, setActiveMembers] = useState("");
  const [eventsOrganized, setEventsOrganized] = useState("");
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const res = await aboutChapterApi.get();
        setAbout(res.data);
        setDescription(res.data?.description || "");
        setActiveMembers(res.data?.activeMembers || "");
        setEventsOrganized(res.data?.eventsOrganized || "");
      } catch (err) {
        console.error("Error fetching about chapter:", err);
      }
    };
    fetchAbout();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    if (image) formData.append("image", image);
    formData.append("description", description);
    formData.append("activeMembers", activeMembers);
    formData.append("eventsOrganized", eventsOrganized);

    try {
      await aboutChapterApi.update(formData);
      alert("✅ About Chapter updated successfully!");
      window.location.reload();
    } catch (err) {
      console.error("Update failed:", err);
      alert("❌ Failed to update about chapter.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-about-container">
      <div className="admin-panel-header">
        <div className="panel-title-group">
          <i className="fas fa-info-circle title-icon"></i>
          <div>
            <h2>Update “About Our Chapter”</h2>
            <p className="panel-subtitle">Manage chapter overview text, showcase photo, and live counters</p>
          </div>
        </div>
      </div>

      <div className="admin-about-grid">
        {/* Left: Preview Card */}
        <div className="about-preview-column">
          <h3 className="preview-label">Live Preview</h3>
          <div className="about-showcase-preview-card">
            <div className="preview-image-box">
              <ImageLoader
                src={previewUrl || (about?.imagePath ? getImageUrl(about.imagePath) : "")}
                alt="About Chapter"
                className="preview-img"
              />
              <div className="preview-floating-pill">
                <i className="fas fa-users"></i>
                <span>Building Connections. Creating Impact.</span>
              </div>
            </div>

            <div className="preview-stats-row">
              <div className="preview-stat-card">
                <i className="fas fa-user-friends stat-ic"></i>
                <div>
                  <span className="stat-val">{activeMembers || 0}+</span>
                  <span className="stat-lbl">Active Members</span>
                </div>
              </div>
              <div className="preview-stat-card">
                <i className="fas fa-calendar-check stat-ic"></i>
                <div>
                  <span className="stat-val">{eventsOrganized || 0}+</span>
                  <span className="stat-lbl">Events Conducted</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right: Form */}
        <div className="about-form-column">
          <form onSubmit={handleSubmit} className="admin-glass-form">
            <div className="admin-form-group">
              <label><i className="fas fa-image"></i> Replace Showcase Photo</label>
              <input type="file" accept="image/*" onChange={handleImageChange} />
            </div>

            <div className="admin-form-group">
              <label><i className="fas fa-align-left"></i> Chapter Overview Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows="6"
                placeholder="Enter chapter description..."
                required
              />
            </div>

            <div className="about-counts-row">
              <div className="admin-form-group">
                <label><i className="fas fa-users"></i> Active Members Count</label>
                <input
                  type="number"
                  value={activeMembers}
                  onChange={(e) => setActiveMembers(e.target.value)}
                  placeholder="e.g. 80"
                  required
                />
              </div>

              <div className="admin-form-group">
                <label><i className="fas fa-calendar-alt"></i> Events Conducted</label>
                <input
                  type="number"
                  value={eventsOrganized}
                  onChange={(e) => setEventsOrganized(e.target.value)}
                  placeholder="e.g. 60"
                  required
                />
              </div>
            </div>

            <button type="submit" className="admin-btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <i className="fas fa-circle-notch fa-spin"></i> Updating...
                </>
              ) : (
                <>
                  <i className="fas fa-save"></i> Save &amp; Publish Changes
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminAboutChapter;
